import { useEffect, useLayoutEffect } from "react"
import { useTransform, useMotionValue } from "framer-motion"

import { useViewport } from "contexts/Viewport"
import { useConsole } from "contexts/Console"
import { useEnv } from "contexts/Env"

import { WIDTHS } from "components/media/ImageCLD"

import { useErsive } from "./context"
import { getTemplate } from "./utils"

export default function Sequence({ start, end, prog }) {
  const console = useConsole()
  const viewport = useViewport()
  const env = useEnv()

  const { frames, canCtx, sources, frameNb, input, output } = useErsive()

  const transProg = useTransform(prog, input, output)

  const currentFrame = useMotionValue(0)

  async function feedImgArray() {
    const orient = viewport.orientation.get()
    if (orient === "portrait" && !!frames.get("portrait").size) {
      return Promise.resolve()
    }
    if (orient === "landscape" && !!frames.get("landscape").size) {
      return Promise.resolve()
    }

    const template = getTemplate(orient === "portrait", sources, env)
    const promArr = []

    console.verbose("• template", template)

    for (let i = start; i <= end; i++) {
      promArr.push(
        new Promise((resolve, reject) => {
          const img = new Image()
          img.srcset = WIDTHS.reduce((acc, width) => {
            acc.push(`${template}${`${Math.abs(i).toString().padStart(4, "0")}`}`)
            return acc
          }, []).join(", ")
          img.sizes = "100vw"
          img.onload = () => resolve(img)
          img.onerror = err => reject(err)
        })
      )
    }

    return Promise.all(promArr).then(arr => frames.set(orient, new Map(arr.map((o, i) => [i, o]))))
  }

  const updateImage = () => {
    const o = viewport.orientation.get()
    if (!frames.get(o).size) return
    canCtx.current.clearRect(0, 0, sources.get(o).width, sources.get(o).height)
    canCtx.current.drawImage(frames.get(o).get(currentFrame.get()), 0, 0, sources.get(o).width, sources.get(o).height)
  }
  function onProg(p) {
    currentFrame.set(Math.min(frameNb, Math.ceil(p * frameNb)))
  }
  useEffect(() => transProg.onChange(onProg))
  useLayoutEffect(() => onProg(transProg.get()))

  function onFrame(f) {
    updateImage()
  }
  useEffect(() => currentFrame.onChange(onFrame))

  function onOrChange(o) {
    if (frames.get(o).size) return
    feedImgArray().then(() => updateImage(currentFrame.get()))
  }
  useEffect(() => viewport.orientation.onChange(onOrChange))

  useEffect(() => {
    feedImgArray().then(() => updateImage(0))
  }, [])

  return null
}

/* 
export default function Sequence({ start, end, prog }) {
  const console = useConsole()
  const viewport = useViewport()
  const env = useEnv()

  const { frames, canCtx, sources, frameNb, input, output } = useErsive()

  const transProg = useTransform(prog, input, output)

  const currentFrame = useMotionValue(0)

  async function feedImgArray() {
    if (viewport.isMobile.get() && !!frames.get("portrait").size) {
      return Promise.resolve()
    }
    if (!viewport.isMobile.get() && !!frames.get("landscape").size) {
      return Promise.resolve()
    }

    const template = getTemplate(viewport.isMobile.get(), sources, env)
    const promArr = []
    const orient = viewport.isMobile.get() ? "portrait" : "landscape"

    for (let i = start; i <= end; i++) {
      promArr.push(
        new Promise((resolve, reject) => {
          const img = new Image()
          img.srcset = WIDTHS.reduce((acc, width) => {
            acc.push(`${template}${`${Math.abs(i).toString().padStart(4, "0")}`}`)
            return acc
          }, []).join(", ")
          img.sizes = "100vw"
          img.onload = () => resolve(img)
          img.onerror = err => reject(err)
        })
      )
    }

    return Promise.all(promArr).then(arr => frames.set(orient, new Map(arr.map((o, i) => [i, o]))))
  }

  const updateImage = () => {
    const o = viewport.isMobile.get() ? "portrait" : "landscape"
    if (!frames.get(o).size) return
    canCtx.current.clearRect(0, 0, sources.get(o).width, sources.get(o).height)
    canCtx.current.drawImage(frames.get(o).get(currentFrame.get()), 0, 0, sources.get(o).width, sources.get(o).height)
  }
  function onProg(p) {
    currentFrame.set(Math.min(frameNb, Math.ceil(p * frameNb)))
  }
  useEffect(() => transProg.onChange(onProg))

  function onFrame(f) {
    updateImage()
  }
  useEffect(() => currentFrame.onChange(onFrame))

  function onOrChange(bool) {
    const o = bool ? "portrait" : "landscape"
    if (frames.get(o).size) return
    feedImgArray().then(() => updateImage(currentFrame.get()))
  }
  useEffect(() => viewport.isMobile.onChange(onOrChange))

  useEffect(() => {
    feedImgArray().then(() => updateImage(0))
  }, [])

  return null
}
*/
